import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import ProductCard from "@/components/store/ProductCard";
import Reveal from "@/components/store/Reveal";

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const active = params.get("category") || "";

  useEffect(() => { api.get("/categories").then(({ data }) => setCategories(data)).catch(() => {}); }, []);

  useEffect(() => {
    setLoading(true);
    api.get("/products", { params: active ? { category: active } : {} })
      .then(({ data }) => setProducts(data)).catch(() => {}).finally(() => setLoading(false));
  }, [active]);

  const setCat = (slug) => { slug ? setParams({ category: slug }) : setParams({}); };

  return (
    <div className="px-6 md:px-12 py-14" data-testid="shop-page">
      <div className="text-center mb-10">
        <p className="eyebrow mb-3">The Collection</p>
        <h1 className="font-heading text-4xl md:text-6xl tracking-tight">Shop the Voyage</h1>
      </div>

      <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 mb-12 border-b hairline pb-6">
        <button onClick={() => setCat("")} data-testid="filter-all"
                className={`font-body uppercase tracking-wide2 text-[0.65rem] pb-1 border-b transition-colors ${!active ? "border-ink text-ink" : "border-transparent text-ink/50 hover:text-ink"}`}>All</button>
        {categories.map((c) => (
          <button key={c.id} onClick={() => setCat(c.slug)} data-testid={`filter-${c.slug}`}
                  className={`font-body uppercase tracking-wide2 text-[0.65rem] pb-1 border-b transition-colors ${active === c.slug ? "border-ink text-ink" : "border-transparent text-ink/50 hover:text-ink"}`}>{c.title}</button>
        ))}
      </div>

      {loading ? (
        <p className="text-center font-heading text-2xl text-ink/40 py-20">Loading the collection…</p>
      ) : products.length === 0 ? (
        <p className="text-center font-heading text-2xl text-ink/50 py-20">No pieces here yet — check back soon.</p>
      ) : (
        <div className="mx-auto max-w-[1300px] grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {products.map((p, i) => <Reveal key={p.id} delay={(i % 4) * 80}><ProductCard product={p} /></Reveal>)}
        </div>
      )}
    </div>
  );
}
